angular.module('app')
    .controller('AppCtrl',
        function() {});
